import React, { useState, useEffect, useRef } from "react";
import { Element } from "react-scroll";

const EventList = ({ items, initialLoad }) => {
  const [paddingBottom, setPaddingBottom] = useState(0);
  const lastImageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const updatePadding = () => {
      if (lastImageRef.current && containerRef.current) {
        const lastImageHeight = lastImageRef.current.clientHeight;
        const windowHeight = window.innerHeight;
        setPaddingBottom(windowHeight - lastImageHeight);
      }
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);

    return () => {
      window.removeEventListener("resize", updatePadding);
    };
  }, [items]);

  return (
    <div
      ref={containerRef}
      className="flex flex-col gap-10"
      style={{ paddingBottom: `${paddingBottom}px` }}
    >
      {items?.map((item, index) => (
        <Element
          name={`flyer-${index}`}
          key={index}
          className={`${initialLoad && index === 0 ? "active" : "pt-0.5"}`}
        >
          <img
            src={item}
            alt={`Flyer ${index}`}
            ref={index === items.length - 1 ? lastImageRef : null}
          />
        </Element>
      ))}
    </div>
  );
};

export default EventList;
